import React from 'react';
import { motion } from 'framer-motion';
import { SlideStage } from '../../components/deck/SlideStage';
const VEXU_LOGO = 'https://cdn.magicpatterns.com/uploads/3A8d459aXLumR8KKFCQtrD/vexu_logo.svg';
const ease = [0.22, 0.61, 0.36, 1] as const;
const CONTACT = [{
  label: 'fadi@vexu.ai',
  href: 'mailto:fadi@vexu.ai'
}, {
  label: '+971 58 537 7090',
  href: 'tel:+971585377090'
}, {
  label: 'vexu.ai',
  href: 'https://vexu.ai',
  external: true
}];
export function ThankYouSlide() {
  return <SlideStage data-id="element-2760" data-mp="109ymhmpez8fw">
      <div className="deck-type absolute inset-0 overflow-hidden bg-[#FAFCF9]" data-id="element-2761" data-mp="10bjfh7w2yjbn">
        <div className="absolute inset-0" style={{
        background: 'radial-gradient(ellipse 62% 55% at 50% 108%, rgba(0,200,83,0.10) 0%, rgba(250,252,249,0) 60%), linear-gradient(180deg, #FBFDFA 0%, #F5F8F3 58%, #EFF3ED 100%)'
      }} data-id="element-2762" data-mp="vj8ee1plsrhi" />

        {/* Closing communication lines */}
        <svg className="pointer-events-none absolute inset-0 h-full w-full" viewBox="0 0 1600 900" aria-hidden="true" data-id="element-2763" data-mp="1j7rq6r7v3mec">
          {['M-80 700 C 380 640, 900 780, 1680 640', 'M-80 790 C 420 740, 980 860, 1680 740'].map((d, i) => <motion.path key={d} d={d} fill="none" stroke="rgba(0,153,64,0.14)" strokeWidth={1} initial={{
          pathLength: 0,
          opacity: 0
        }} animate={{
          pathLength: 1,
          opacity: 1
        }} transition={{
          duration: 2.8,
          delay: 0.6 + i * 0.4,
          ease
        }} data-id="element-2764" data-mp="3gqyhodh3x4p2" data-mpi={i} />)}
          {[712, 802].map((cy, i) => <motion.circle key={cy} r={3.5} fill="rgba(0,153,64,0.3)" initial={{
          opacity: 0
        }} animate={{
          opacity: [0, 0.9, 0],
          cx: [-60, 1660],
          cy
        }} transition={{
          duration: 13 + i * 3,
          repeat: Infinity,
          delay: 2 + i * 2,
          ease: 'linear'
        }} data-id="element-2765" data-mp="2xufcfz9fc0xs" data-mpi={i} />)}
        </svg>

        {/* Brand header */}
        <motion.div className="absolute flex items-center gap-3" style={{
        left: 112,
        top: 56
      }} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        ease
      }} data-id="element-2766" data-mp="ui94fbl102bq">
          <img src={VEXU_LOGO} alt="" className="w-7 h-7 object-contain" data-id="element-2767" data-mp="1i9esge14e0x4" />
          <span className="text-[16px] font-bold tracking-tight text-[#0B1712]" data-id="element-2768" data-mp="1ibhhovug7q0s">
            Vexu.ai
          </span>
        </motion.div>
        <motion.span className="absolute text-[11px] font-semibold uppercase tracking-[0.28em] text-[#8A998F]" style={{
        right: 112,
        top: 62
      }} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        ease
      }} data-id="element-2769" data-mp="18j203zn2d3gf">
          19 · Thank You
        </motion.span>

        {/* Headline */}
        <h1 className="absolute text-[54px] font-semibold leading-[1.14] tracking-[-0.03em] text-[#0B1712]" style={{
        left: 112,
        top: 268,
        width: 1120
      }} data-id="element-2770" data-mp="1w734qxh4fzqk">
          {["Let's build the future", 'of AI communication.'].map((line, i) => <motion.span key={line} className="block" initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.3 + i * 0.18,
          ease
        }} data-id="element-2771" data-mp="2dhp7jmr2qwnr" data-mpi={i}>
              {line}
            </motion.span>)}
        </h1>

        {/* Founder contact */}
        <motion.div className="absolute" style={{
        left: 112,
        top: 470,
        width: 620
      }} initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 1.1,
        ease
      }} data-id="element-2772" data-mp="2w99ilav5ymdf">
          <p className="text-[21px] font-semibold tracking-[-0.015em] text-[#0B1712]" data-id="element-2773" data-mp="3690ffj775dgo">
            Fadi Rayyan
          </p>
          <p className="mt-1.5 text-[14px] text-[#5A6B60]" data-id="element-2774" data-mp="bs9l9xf5k19w">
            Founder &amp; CEO · VEXU AI
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-x-7 gap-y-3" data-id="element-2775" data-mp="6teqdx3wum9f">
            {CONTACT.map(item => <a key={item.label} href={item.href} {...item.external ? {
            target: '_blank',
            rel: 'noreferrer'
          } : {}} className="text-[16px] text-[#33463B] underline-offset-[6px] transition-colors hover:text-vexu-700 hover:underline" data-id="element-2776" data-mp="kktdog4up9ma">
                {item.label}
              </a>)}
          </div>
        </motion.div>

        {/* Closing */}
        <motion.div className="absolute border-t border-[#0B1712]/[0.09] pt-6" style={{
        left: 112,
        right: 112,
        bottom: 68
      }} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 1.7,
        ease
      }} data-id="element-2777" data-mp="3t0d2n2yho5vj">
          <p className="text-[22px] font-semibold tracking-[-0.02em] text-vexu-700" data-id="element-2778" data-mp="18ci9w7ksmi8i">
            One AI engine. From every call to every conversation.
          </p>
          <p className="mt-3 text-[11.5px] font-medium uppercase tracking-[0.22em] text-[#A3AFA7]" data-id="element-2779" data-mp="1ktjaesm4dz0p">
            VEXU AI · International Utility Patent Pending
          </p>
        </motion.div>
      </div>
    </SlideStage>;
}